// extracted by mini-css-extract-plugin
export var orderDetails = "_sz-2";
export var orderImage = "_sz-1";
export var orderMeta = "_sz-3";
export var orderSummary = "_sz-0";
export var rightArrow = "_sz-4";